<template>
  <b-overlay :show="loadingFile" class="row view-panel" v-bind:class="{'toggle': toggle}">
    <!-- BUTTONS -->
    <div class="col-md-12 button-panel">
      <div class="d-flex justify-end">
        <vs-button
          v-has-permission="'ED082'"
          radius
          v-tooltip="'Buscar'"
          class="action mr-2"
          color="primary"
          icon="search"
          @click="goToSearch()"
          data-cy="search"
        />
        <span class="separator"></span>
        <vs-button
          v-has-permission="'ED144'"
          radius
          v-tooltip="'Nuevo documento predefinido'"
          class="action mr-2"
          color="primary"
          icon="note_add"
          @click="newDocument"
          data-cy="new-document"
          :disabled="!canEdit"
        />
        <vs-button
          v-has-permission="'ED275'"
          v-if="actualFolder && actualFolder.type === 'folder'"
          radius
          v-tooltip="'Nuevo documento desde template'"
          class="action mr-2"
          color="primary"
          icon="content_copy"
          @click="handleNewTemplateDocument"
          data-cy="new-document-template"
          :disabled="noHavPermissions || !canEdit"
          :class="{ 'cursor-not-allowed': noHavPermissions}"
        />
        <vs-button
          v-show="activeElement && activeElement.type === 'file'"
          radius
          v-tooltip="'Ver'"
          class="action mr-2"
          color="primary"
          icon="file_download"
          @click="openElement"
          data-cy="open-element"
        />
        <vs-button
          v-has-permission="'ED082|FEB99'"
          v-show="getSelectedRepositoryId || getSelectedFolderId"
          radius
          v-tooltip="'Agregar carpeta'"
          class="action mr-2"
          color="primary"
          icon="create_new_folder"
          @click="addFolder"
          data-cy="add-folder"
          :disabled="userPermissions.write === 0
            && userPermissions.totalControl === 0"
        />
        <vs-button
          v-has-permission="'ED092|FEB99'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Editar carpeta'"
          class="action mr-2"
          color="primary"
          icon="edit"
          data-cy="edit"
          :class="{ 'cursor-not-allowed': isReadOnly}"
          :disabled="isReadOnly"
          @click="editFolder"
        />
        <vs-button
          v-has-permission="'ED093|FEB99'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Eliminar carpeta'"
          class="action mr-2"
          color="primary"
          icon="delete"
          @click="deleteFolder"
          data-cy="delete-folder"
          :disabled="isReadOnly"
          :class="{
            'cursor-not-allowed': isReadOnly
          }"
        />
        <vs-button
          v-has-permission="'ED084'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Kanban de carpeta'"
          class="action mr-2"
          color="primary"
          icon="grid_view"
          @click="goToKanbanFolder"
          data-cy="kanban-folder"
          :disabled="noHavPermissions"
          :class="{ 'cursor-not-allowed': noHavPermissions
          }"
        />
        <vs-button
          v-has-permission="'ED078'"
          v-if="activeElement && activeElement.type === 'file' && !isGore && !isInh"
          radius
          v-tooltip="'Enviar a flujo.'"
          class="action mr-2"
          color="primary"
          icon="call_split"
          @click="sendToFlow"
          data-cy="send-to-flow"
          :disabled="noHavPermissions || !canEdit"
          :class="{ 'cursor-not-allowed': (noHavPermissions || !canEdit) }"
        />
        <vs-button
          v-has-permission="'ED078'"
          v-if="activeElement && activeElement.type === 'file' && (isGore || isInh)"
          radius
          v-tooltip="'Enviar a flujo.'"
          class="action mr-2"
          color="primary"
          icon="call_split"
          @click="sendToFlowGoreConfirm"
          data-cy="send-to-flow"
          :disabled="noHavPermissions || !canEdit"
          :class="{ 'cursor-not-allowed': (noHavPermissions || !canEdit) }"
        />
        <vs-button
          v-has-permission="'ED083'"
          v-show="getSelectedRepositoryId || getSelectedFolderId"
          radius
          v-tooltip="'Agregar documento'"
          class="action mr-2"
          color="primary"
          icon="cloud_upload"
          @click="addFile"
          data-cy="add-file"
          :disabled="isReadOnly"
        />
        <vs-button
          v-has-permission="'ED243'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Descargar carpeta'"
          class="action mr-2"
          color="primary"
          icon="cloud_download"
          @click="downloadFolder"
          data-cy="add-file"
        />
        <vs-button
          v-has-permission="'ED240'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Enviar carpeta a flujo'"
          class="action mr-2"
          color="primary"
          icon="call_split"
          data-cy="send-folder-to-flow"
          :class="{ 'cursor-not-allowed': userPermissions.read === 0 && userPermissions.write === 0
            && userPermissions.totalControl === 0
          }"
          :disabled="(userPermissions.read === 0 && userPermissions.write === 0 &&
           userPermissions.totalControl === 0) || !canEdit"
          @click="sendFolderToFlow"
        />
        <div class="flex">
          <vs-button
            v-has-permission="'ED239'"
            radius
            v-tooltip="'Seleccionar archivos para enviar a flujo'"
            class="mr-2"
            :class="{
              'pr-2': !navigationElementsSelectionEnabled
                && selectionType !== selectionTypes.SEND_FILE_TO_FLOW
            }"
            color="primary"
            icon="checklist"
            @click="toggleSendFilesToFlowSelection"
            data-cy="toggle-send-files-to-flow-selection"
            :disabled="!canEdit"
          >
            {{
              navigationElementsSelectionEnabled
                ? (selectedNavigationElements.length + '/' + maxSendFilesToFlowSelection)
                : ''
            }}
          </vs-button>
          <vs-button
            v-if="navigationElementsSelectionEnabled"
            v-has-permission="'ED082'"
            radius
            v-tooltip="'Aceptar selección'"
            class="ml-2"
            color="success"
            icon="check"
            @click="handleAcceptSelection()"
            data-cy="accept-selection"
          />
          <vs-button
            v-if="navigationElementsSelectionEnabled"
            v-has-permission="'ED082'"
            radius
            v-tooltip="'Cancelar selección'"
            class="ml-2"
            color="danger"
            icon="close"
            @click="handleCancelSelection()"
            data-cy="cancel-selection"
          />
        </div>
        <vs-button
          v-has-permission="'ED094'"
          v-show="activeElement && activeElement.type === 'file' && canWrite"
          radius
          v-tooltip="'Editar datos del documento'"
          class="action mr-2"
          color="primary"
          icon="edit"
          @click="editDataFile"
          data-cy="edit-file"
          :disabled="isReadOnly"
          :class="{ 'cursor-not-allowed': isReadOnly }"
        />
        <vs-button
          v-has-permission="'ED241'"
          v-show="activeElement && activeElement.type === 'file' && canWrite && isDocx"
          radius
          v-tooltip="'Editar el documento'"
          class="action mr-2"
          color="primary"
          icon="edit_off"
          @click="openEdictDocument"
          data-cy="edit-document"
          :disabled="isReadOnly || !canEdit"
          :class="{ 'cursor-not-allowed': isReadOnly || !canEdit} "
        />
        <vs-button
          v-show="activeElement && activeElement.type === 'file'"
          radius
          v-has-permission="'ED085'"
          v-tooltip="'Kanban de archivo'"
          class="action mr-2"
          color="primary"
          icon="dashboard"
          @click="goToKanban"
          data-cy="file-kanban"
          :disabled="noHavPermissions"
          :class="{ 'cursor-not-allowed': noHavPermissions
          }"
        />
        <vs-button
          v-has-permission="'ED095'"
          v-show="activeElement && activeElement.type === 'file'"
          radius
          v-tooltip="'Eliminar documento'"
          class="action mr-2"
          color="primary"
          icon="delete"
          @click="deleteFile"
          data-cy="delete-file"
          :disabled="userPermissions.write === 0"
          :class="{ 'cursor-not-allowed': userPermissions.write === 0
          }"
        />
        <vs-button
          v-has-permission="'RPS99'"
          v-show="activeElement && activeElement.type === 'file'
            && activeElement.codeType === 'CPSH'"
          radius
          v-tooltip="'Editar información del convenio'"
          class="action mr-2"
          color="primary"
          icon="supervisor_account"
          @click="editCpshInfo"
          data-cy="edit-cpsh-info"
        />
        <vs-button
          v-has-permission="'ED240'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Reglas de la carpeta'"
          class="action mr-2"
          color="primary"
          icon="settings"
          data-cy="configure-rule"
          :class="{ 'cursor-not-allowed': !isSuperAdmin && ( userPermissions.read === 0
          && userPermissions.write === 0
            && userPermissions.totalControl === 0)
          }"
          :disabled="!isSuperAdmin && ( userPermissions.read === 0 && userPermissions.write === 0
            && userPermissions.totalControl === 0)"
          @click="configureRules"
        />

        <vs-button
          v-has-permission="'RPS82'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Bloquear edición en linea'"
          class="action mr-2"
          color="primary"
          :icon="'lock'"
          data-cy="configure-block-editing"
          :class="{
            'cursor-not-allowed': !isSuperAdmin
            && (
              userPermissions.read === 0
            && userPermissions.write === 0
            && userPermissions.totalControl === 0
            )
          }"
          :disabled="!isSuperAdmin && ( userPermissions.read === 0 && userPermissions.write === 0
            && userPermissions.totalControl === 0)"
          @click="handleConfigureLockEditing"
        />
        <vs-button
          v-has-permission="'RPS83'"
          v-show="activeElement && activeElement.type === 'folder'"
          radius
          v-tooltip="'Marcar como contenedora de templates'"
          class="action mr-2"
          color="primary"
          icon-pack="feather"
          icon="icon-package"
          data-cy="configure-template-editing"
          :class="{
            'cursor-not-allowed': !isSuperAdmin
              && (
                userPermissions.read === 0
                && userPermissions.write === 0
                && userPermissions.totalControl === 0
                )
          }"
          :disabled="!isSuperAdmin && ( userPermissions.read === 0 && userPermissions.write === 0
            && userPermissions.totalControl === 0)"
          @click="handleConfigureTemplate"
        />
      </div>
    </div>
    <!-- NAVEGADOR DE DIRECTORIOS Y DOCUMENTOS -->
    <div class="col-md-12" @dragover="dragover" @dragleave="dragleave" @drop="drop">
      <div
        class="mt-4 wrap-table shadow bg-white rounded overflow-y-scroll view-table drag"
        v-if="showDrangAndDropUploader"
      >
        <input
          type="file"
          multiple
          name="fields[assetsFieldHandle][]"
          id="assetsFieldHandle"
          class="hidden"
          @change="onChange"
          ref="file"
        />
        <div class="help">
          Suelta aquí los archivos que quieres subir a la carpeta
          <strong>{{ elementName }}</strong><br/>
          Se subirán automáticamente en cuanto los sueltes
        </div>
        <div class="drop-icon-holder">
          <font-awesome-icon
            :icon="['fa', 'arrow-alt-circle-down']"
            class="drop-icon"
          />
        </div>
        <div class="uploading-progress" v-if="filesToUpload.length > 0">
          <div class="progress-wrapper">
            <div class="h-5 animate-pulse bg-grey-light rounded-pill w-5 mr-2 progress-content"/>
            <div class="progress-content">
              Subiendo <strong>{{ filesToUpload.length }}</strong> archivos ({{ progress }} %)
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-4 wrap-table shadow bg-white rounded overflow-y-scroll view-table"
        v-if="!dragging"
      >
        <table class="w-100 rounded">
          <thead class="fb-bg-primary" style="color:white;">
          <tr>
            <th v-if="navigationElementsSelectionEnabled">
              Selección
            </th>
            <th>
              Estado
            </th>
            <th>
              Nombre
            </th>
            <th class="text-center">
              Tamaño
            </th>
            <th>
              Fecha Creación
            </th>
            <th>
              Propietario
            </th>
            <th>
              Versiones anteriores
            </th>
          </tr>
          </thead>
          <tbody id="folder-elements">
          <!-- FOLDER ELEMENTS -->
          <NavigationElement
            v-for="element in folderElements"
            :element="element" :key="element.id"
            data-cy="folder"
          />
          <!-- FILE ELEMENTS -->
          <NavigationElement
            v-for="element in fileElements"
            :element="element" :key="element.id"
            data-cy="file"
            :selection-enabled="navigationElementsSelectionEnabled"
            :is-selectable="isSelectableNavigationElement(element)"
            @select-navigation-element="handleSelectNavigationElement"/>
          <!-- EMPTY FOLDER MESSAGE -->
          <tr v-if="isEmptyFolder">
            <td colspan="5">
              <div class="d-flex justify-center m-5">
                <span>Ups! esta carpeta esta vacía.</span>
              </div>
            </td>
          </tr>
          </tbody>
          <!-- SKELETON LOADER -->
          <tr v-show="loadingElements">
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-50" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
          </tr>
          <tr v-show="loadingElements">
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-50" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <FileFormView v-if="modalName" :isEdit="isEdit"/>
    <FolderFormView v-if="modalName" :isEdit="isEdit"/>
    <NewCustomDocument v-if="modalName"/>
    <b-modal
      v-model="showEditCpshModal"
      id="editCpshModal"
      :title="cpshModalTitle"
      no-close-on-backdrop
      hide-footer
      centered
      size="lg"
      data-cy="edit-cpsh-modal"
    >
      <b-overlay :show="loadingCpshData">
        <div v-if="cpshData">
          <div
            v-for="field in editableFields"
            :key="field.id"
            class="mb-3"
          >
            <label>
              <strong>{{ field.title }}</strong>
              <span v-if="!field.opcional" class="text-danger">*</span>
            </label>

            <list-user
              v-if="field.type === 'usuarios'"
              autocomplete
              label=""
              class="mb-1"
              :name="`cpshField-${field.id}`"
              :data-cy="`cpsh-field-${field.id}`"
              :data-vv-as="field.title"
              v-model="cpshEditForm[field.id]"
              @full-user="cpshEditForm[`${field.id}Complete`] = $event"
            />

            <v-select
              v-else-if="field.type === 'grupos'"
              :name="`cpshField-${field.id}`"
              :data-cy="`cpsh-field-${field.id}`"
              :placeholder="`Seleccione ${field.title}`"
              v-model="cpshEditForm[field.id]"
              :options="cpshCompanyGroups"
              :loading="loadingCpshGroups"
              label="nombre"
            />

            <b-form-input
              v-else-if="field.type === 'texto'"
              v-model="cpshEditForm[field.id]"
              :data-cy="`cpsh-field-${field.id}`"
              :placeholder="field.placeholder || field.title"
            />

            <b-form-textarea
              v-else-if="field.type === 'textolargo' || field.type === 'textomail'"
              v-model="cpshEditForm[field.id]"
              :data-cy="`cpsh-field-${field.id}`"
              :placeholder="field.placeholder || field.title"
              rows="3"
            />

            <b-form-input
              v-else-if="field.type === 'correomultiple'"
              v-model="cpshEditForm[field.id]"
              :data-cy="`cpsh-field-${field.id}`"
              placeholder="correo1@ejemplo.com, correo2@ejemplo.com"
            />

            <b-button
              v-else-if="field.type === 'sino'"
              class="btn-block"
              variant="primary"
              :data-cy="`cpsh-field-${field.id}`"
              @click="cpshEditForm[field.id] = cpshEditForm[field.id] === 'si' ? 'no' : 'si'"
            >
              {{ cpshEditForm[field.id] === 'si' ? 'Sí' : 'No' }}
            </b-button>

            <select
              v-else-if="field.type === 'opciones'"
              class="form-control"
              v-model="cpshEditForm[field.id]"
              :data-cy="`cpsh-field-${field.id}`"
            >
              <option
                v-for="option in (field.opciones || [])"
                :key="option.valor"
                :value="option.valor"
              >
                {{ option.descripcion }}
              </option>
            </select>

            <p
              v-else-if="field.type === 'info'"
              class="text-muted small mb-0"
              :data-cy="`cpsh-field-${field.id}`"
            >
              {{ field.default || '' }}
            </p>

            <b-alert v-else show variant="warning" class="py-1 mb-0">
              Tipo de campo no soportado: {{ field.type }}
            </b-alert>

            <span
              v-if="cpshFieldErrors[field.id]"
              class="text-danger text-sm form-error-message"
            >
              El campo {{ field.title }} es obligatorio
            </span>
          </div>

          <div class="text-right mt-3">
            <b-button
              variant="outline-secondary"
              class="mr-2"
              @click="showEditCpshModal = false"
              data-cy="cpsh-cancel"
            >
              Cancelar
            </b-button>
            <b-button
              variant="primary"
              @click="saveCpshInfo"
              :disabled="savingCpsh"
              data-cy="cpsh-save"
            >
              {{ savingCpsh ? 'Guardando...' : 'Guardar cambios' }}
            </b-button>
          </div>
        </div>
        <div v-else-if="!loadingCpshData" class="text-center py-4">
          <p class="text-danger">No se pudo cargar la información del convenio.</p>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      title="Información para el Expediente"
      id="fillInfoFile"
      ref="fillInfoFile"
      hide-footer
      centered
    >
      <div class="row">
        <div class="col-12">
          <list-user-groups
            class="w-100"
            autocomplete
            data-cy="select-grupo"
            only-groups
            label="Grupo al que irá asociado el expediente (*)"
            name="groupUserFile"
            v-model="groupUserFile"
            ref="groupUserFile"
          />
          <div v-if="errorGroup && !groupUserFile">
            <h4 class="text-danger">
              Por favor selecciona un grupo para asociarlo al expediente
            </h4>
          </div>
          <div class="text-right">
            <b-button
              :disabled="loadingFile"
              variant="primary"
              data-cy="boton-vale"
              @click="sendToFlowGore"
            >
              Vale
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="showLockEditingModal"
      id="lockEditingModal"
      title="Configurar bloqueo de edición en línea"
      hide-footer
      centered
      data-cy="modal-lock-editing"
    >
      <div class="mb-3" data-cy="modal-lock-editing-info">
        ¿Desea bloquear la edición en línea de archivos para la carpeta
        <b>{{ activeElement && activeElement.name }}</b>
        ?
      </div>
      <div class="d-flex align-items-center mb-3">
        <label class="mr-2" for="switch-lock-editing" data-cy="label-switch-lock-editing">
          Bloquear edición en línea
        </label>
        <b-form-checkbox
          id="switch-lock-editing"
          v-model="lockEditingSwitch"
          switch
          data-cy="switch-lock-editing"
        >
        </b-form-checkbox>
      </div>
      <div class="d-flex justify-end">
        <b-button
          variant="primary"
          class="mr-2"
          @click="confirmLockEditing"
          data-cy="btn-confirm-lock-editing"
          :disabled="loadingLockEditing"
          v-if="!loadingLockEditing"
        >
          Confirmar
        </b-button>
        <b-button
          variant="primary"
          class="mr-2"
          disabled
          v-if="loadingLockEditing"
        >
          <b-spinner small type="grow" class="mr-2"/>
          Procesando...
        </b-button>
        <b-button
          variant="secondary"
          @click="showLockEditingModal = false"
          data-cy="btn-cancel-lock-editing"
          :disabled="loadingLockEditing"
        >
          Cancelar
        </b-button>
      </div>
      <b-alert
        v-if="lockEditingFeedback"
        variant="success"
        show
        class="mt-3"
        data-cy="feedback-lock-editing"
      >
        {{ lockEditingFeedback }}
      </b-alert>
    </b-modal>
    <b-modal
      v-model="showTemplateModal"
      id="templateModal"
      title="Configurar como plantilla"
      hide-footer
      centered
      data-cy="modal-template-editing"
    >
      <div class="mb-3" data-cy="modal-template-editing-info">
        ¿Desea marcar la carpeta <b>{{ activeElement && activeElement.name }}</b> como plantilla?
      </div>
      <div class="d-flex align-items-center mb-3">
        <label class="mr-2" for="switch-template-editing" data-cy="label-switch-template-editing">
          Marcar como plantilla
        </label>
        <b-form-checkbox
          id="switch-template-editing"
          v-model="templateSwitch"
          switch
          data-cy="switch-template-editing"
        >
        </b-form-checkbox>
      </div>
      <div class="d-flex justify-end">
        <b-button
          variant="primary"
          class="mr-2"
          @click="confirmTemplate"
          data-cy="btn-confirm-template-editing"
          :disabled="loadingTemplate"
          v-if="!loadingTemplate"
        >
          Confirmar
        </b-button>
        <b-button
          variant="primary"
          class="mr-2"
          disabled
          v-if="loadingTemplate"
        >
          <b-spinner small type="grow" class="mr-2"/>
          Procesando...
        </b-button>
        <b-button
          variant="secondary"
          @click="showTemplateModal = false"
          data-cy="btn-cancel-template-editing"
          :disabled="loadingTemplate"
        >
          Cancelar
        </b-button>
      </div>
      <b-alert
        v-if="templateFeedback"
        variant="success"
        show
        class="mt-3"
        data-cy="feedback-template-editing"
      >
        {{ templateFeedback }}
      </b-alert>
    </b-modal>
    <b-modal
      v-model="showNewTemplateDocumentModal"
      id="newTemplateDocumentModal"
      title="Crear documento desde template"
      hide-footer
      centered
      data-cy="modal-new-document-template"
      no-close-on-backdrop
    >
      <div class="mb-3">
        <div v-if="loadingTemplates">
          <b-spinner small type="grow" class="mr-2"/>
          Cargando templates...
        </div>
        <div v-else>
          <template v-if="wizardStep === 1">
            <!-- Buscador por nombre -->
            <div class="mb-2">
              <input
                v-model="templateSearch"
                type="text"
                class="form-control"
                placeholder="Buscar por nombre..."
                style="max-width: 400px;"
              />
            </div>
            <table class="template-table">
              <thead>
              <tr>
                <th>Nombre</th>
                <th>Fecha creación</th>
                <th>Tamaño</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="file in filteredTemplatesFiles" :key="file.id"
                  :class="{'selected-row': selectedTemplateFile && selectedTemplateFile.id === file.id}"
                  @click="selectTemplateFile(file)"
                  style="cursor:pointer;">
                <td>{{ file.nombre }}</td>
                <td>{{ file.fechaCreacion ? (new Date(file.fechaCreacion)).toLocaleDateString() : '-' }}</td>
                <td>{{ file.pesoArchivo ? (file.pesoArchivo / 1024).toFixed(1) + ' KB' : '-' }}</td>
              </tr>
              </tbody>
            </table>
            <div v-if="filteredTemplatesFiles.length === 0" class="text-center text-muted my-4">
              No se encontraron documentos de template.
            </div>
            <div v-if="templatesPagination.totalPaginas > 1" class="flex justify-between items-center mt-4">
              <vs-button :disabled="templatesPagination.paginaActual === 1"
                         @click="fetchTemplatesFiles(templatesPagination.paginaActual - 1)">Anterior
              </vs-button>
              <span>Página {{ templatesPagination.paginaActual }} de {{ templatesPagination.totalPaginas }}</span>
              <vs-button :disabled="templatesPagination.paginaActual === templatesPagination.totalPaginas"
                         @click="fetchTemplatesFiles(templatesPagination.paginaActual + 1)">Siguiente
              </vs-button>
            </div>
            <div class="mt-4 text-right">
              <vs-button
                color="danger"
                @click="showNewTemplateDocumentModal = false">
                Cancelar
              </vs-button>
            </div>
          </template>
          <template v-else-if="wizardStep === 2">
            <div class="wizard-step-2">
              <div class="mb-3">
                <label for="templateNameInput"><b>Nombre del documento:</b></label>
                <input id="templateNameInput" v-model="editableTemplateName" class="form-control"
                       style="width:100%;max-width:400px;display:block;"/>
              </div>
              <div class="mt-4 text-right">
                <vs-button color="primary" class="mr-2" @click="backToTemplateList">Volver</vs-button>
                <vs-button :disabled="!editableTemplateName" color="success" @click="confirmTemplateSelection">Crear
                  documento
                </vs-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="loadingCopyTemplateDocument"
      id="loadingCopyTemplateDocumentModal"
      title="Creando documento desde template"
      hide-footer
      centered
      data-cy="modal-loading-copy-template-document"
    >
      <div class="d-flex flex-column align-items-center">
        <b-spinner label="Cargando..."/>
        <span class="mt-2">
          Creando documento, por favor espera...
        </span>
      </div>
    </b-modal>
    <b-modal
      v-model="showOpenAfterCopyModal"
      id="openAfterCopyModal"
      title="Documento creado correctamente"
      hide-footer
      centered
      data-cy="modal-open-after-copy"
    >
      <div class="d-flex flex-column justify-content-between">
        <span class="mb-3">El documento se guardó con éxito.</span>
        <div class="d-flex  justify-content-around">
          <vs-button
            @click="handleOpenAfterCopy(false)"
          >
            Cerrar
          </vs-button>
          <vs-button
            color="success"
            class="mr-2"
            @click="handleOpenAfterCopy(true)"
          >
            Abrir documento
          </vs-button>

        </div>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowAltCircleDown, faFolder } from '@fortawesome/free-solid-svg-icons';
import { uuid } from 'vue-uuid';

import { FEBOS_SA } from '../../../../../tests/e2e/specs/ED/constant/empresas';

import { ioGetPrivateUploadUrl, ioUploadFileToPrivateUrl } from '@/febos/servicios/api/herramientas.api';
import FileFormView from '@/febos/global/documentManagement/vistas/modals/FileFormView';
import NewCustomDocument from '@/febos/global/documentManagement/vistas/modals/NewCustomDocument';
import FolderFormView from '@/febos/global/documentManagement/vistas/modals/FolderFormView';
import NavigationElement from '@/febos/global/documentManagement/components/NavigationElement';
import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import PublicationStateTypes from '@/febos/global/documentManagement/mixins/PublicationStateTypes';
import ValidityStateTypes from '@/febos/global/documentManagement/mixins/ValidityStateTypes';
import { ioEDFilesGet, ioGetCustomFile } from '@/febos/servicios/api/repositories.api';
import { ioGetCustomDocument, ioPatchCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';
import { listOptions, listV2Options } from '@/febos/servicios/api/opciones.api';
import { createDnt } from '@/febos/servicios/api/dnt.api';
import router from '@/router';
import SelectionTypes from '@/febos/global/documentManagement/mixins/SelectionTypes';
import ListUserGroups from '@/febos/chile/lists/components/ListUserGroups';
import ListUser from '@/febos/chile/lists/components/ListUser';
import { getUrlEditDocument, isMicrosoftOfficeDocument } from '@/libs/webdav';
import { initProcessFromId } from '@/febos/servicios/api/v2.herramientas.api';
import { app } from '@/main';
import { INH } from '@/constants/companies';

library.add(faFolder, faArrowAltCircleDown);
const baseUrl = 'escritorio-digital/temporal/';
const currentStage = process.env.VUE_APP_AMBIENTE;

export default {
  name: 'navigation-panel',
  components: {
    ListUserGroups,
    ListUser,
    FileFormView,
    FolderFormView,
    NavigationElement,
    NewCustomDocument
  },
  props: {
    toggle: Boolean
  },
  data() {
    return {
      errorGroup: false,
      groupUserFile: undefined,
      loadingFile: false,
      userPermissions: {
        read: 0,
        write: 0,
        totalControl: 0
      },
      folderElements: [],
      fileElements: [],
      templatesElements: [],
      lastTemplatesResponse: null,
      selectedElement: {},
      activeElement: null,
      isEdit: false,
      filesToUpload: [],
      dragging: false,
      individualProgress: {},
      progress: 0,
      navigationElementsSelectionEnabled: false,
      maxSendFilesToFlowSelection: 100,
      selectionTypes: SelectionTypes,
      selectionType: null,
      approvalStateTypes: ApprovalStateTypes,
      publicationStateTypes: PublicationStateTypes,
      validityStateTypes: ValidityStateTypes,
      selectedNavigationElements: [],
      showLockEditingModal: false,
      lockEditingSwitch: false,
      loadingLockEditing: false,
      lockEditingFeedback: '',
      showTemplateModal: false,
      templateSwitch: false,
      loadingTemplate: false,
      templateFeedback: '',
      showNewTemplateDocumentModal: false,
      loadingTemplates: false,
      showEditCpshModal: false,
      loadingCpshData: false,
      savingCpsh: false,
      cpshData: null,
      cpshEditForm: {},
      cpshFieldErrors: {},
      cpshCompanyGroups: [],
      loadingCpshGroups: false,
      editableFields: [],
      templatesFiles: [],
      templatesPagination: {
        paginaActual: 1,
        totalPaginas: 1,
        elementosPorPagina: 10,
        totalElementos: 0
      },
      selectedTemplateFile: null,
      wizardStep: 1,
      editableTemplateName: '',
      selectedTemplateDocument: null,
      newTemplateDocumentName: '',
      loadingCopyTemplateDocument: false,
      // NUEVAS VARIABLES PARA EL FLUJO DE APERTURA
      showOpenAfterCopyModal: false,
      lastCreatedTemplateDocument: null,
      templateSearch: '',
    };
  },
  methods: {
    ...mapActions('DocManagement', [
      'removeFolder',
      'removeFile',
      'uploadFile',
      'blockFolder',
      'templateFolder',
      'findTemplatesFiles'
    ]),
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('RepositoryRules', [
      'viewRules'
    ]),
    ...mapActions('Dnts', [
      'createDnt'
    ]),
    createFileEd(category) {
      console.log('se crea el borrador del expediente', category);
    },
    handleSelectNavigationElement(id, selected) {
      console.log(id, selected);

      if (selected) {
        this.selectedNavigationElements.push(id);
      } else {
        this.selectedNavigationElements = this.selectedNavigationElements.filter((el) => el !== id);
      }
    },
    sendToFlowGoreConfirm() {
      const convertToFile = ['RES', 'OF', 'OFCORE', 'MEMO', 'RESUGDPS', 'RESINH'];
      if (convertToFile.includes(this.activeElement.codeType)) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '¡Advertencia!',
          text: 'Al enviar a flujo este documento, se creará un expediente, ¿Quieres continuar?',
          accept: () => {
            this.checkGroupsForFile();
          },
          acceptText: 'Confirmar',
          cancelText: 'Cancelar'
        });
      } else {
        this.sendToFlow();
      }
    },
    checkGroupsForFile() {
      this.errorGroup = false;
      if (this.groupsUser.length > 1) {
        this.$refs.fillInfoFile.show();
      } else {
        this.sendToFlowGore();
      }
    },
    async sendToFlowGore() {
      if (this.groupsUser.length > 1) {
        if (!this.groupUserFile) {
          this.errorGroup = true;
          return;
        }
      }
      if (this.activeElement.type === 'file') {
        this.loadingFile = true;
        const fileInfo = await ioEDFilesGet({
          repositoryId: 0,
          fileId: this.activeElement.id
        });
        let file = await ioGetCustomFile({
          type: this.activeElement.codeType,
          id: this.activeElement.id
        }, {
          json: 'si', xml: 'no', pdf: 'no', html: 'no'
        });

        let attachments = [];
        if (this.getSelectedFolderId) {
          attachments = this.fileElements;
        }
        file = file.data.document;
        let data = [];
        if (this.isGore) {
          data = await listV2Options({
            grupoOpcion: 'opciones-gore-custom',
            deshabilitado: 'no',
            agrupar: 'si',
            filtros: ''
          });
        } else {
          data = await listV2Options({
            grupoOpcion: 'opciones-exp-custom',
            deshabilitado: 'no',
            agrupar: 'si',
            filtros: ''
          });
        }
        let docOptions = data.data.opciones
          .find((option) => option.valor === this.activeElement.codeType);
        docOptions = {
          ...JSON.parse(docOptions.extra)
        };

        let groupFile = {};
        if (this.groupsUser.length > 1) {
          groupFile = this.groupUserFile
            ? this.$refs.groupUserFile.getOption()
            : '';
        } else {
          const [firstItem] = this.groupsUser;
          groupFile = firstItem;
        }

        let fileNumOf = {};
        const typeNumeration = {
          RES: 'numOf',
          OF: 'numOf',
          OFCORE: 'numOf',
          MEMO: 'numInt',
          RESUGDPS: 'numOf',
          RESINH: 'numOf'
        };
        fileNumOf = {
          dnt: {
            tipo: 'EXP',
            emisorRut: this.company.iut,
            receptorRut: this.company.iut,
            emisorRazonSocial: this.company.razonSocial,
            receptorRazonSocial: this.company.razonSocial,
            compradorArea: groupFile?.label || '',
            emisorContactoNombre: this.currentUser.nombre,
            claseMercadoPublico: typeNumeration[this.activeElement.codeType],
            estado: 3,
            febosId: this.activeElement.id,
            emisorCentroCostoNumero: docOptions.documentoPadre.valor,
            emisorCentroCostoNombre: docOptions.documentoPadre.descripcion,
            emisorSucursalCodigo: docOptions.documentoHijo.valor,
            emisorSucursalDireccion: docOptions.documentoHijo.descripcion,
            condicionDespacho: 1,
            transportePuertoTipo: '1',
            nombreDescriptivo: this.isGore ? (file.textPlainMatter
              ? file.textPlainMatter.slice(0, 50) : file.matter.slice(0, 50)) : file.matter.map((item) => item.text).join(',').slice(0, 50),
            solicitanteGrupoId: groupFile?.id || '',
            solicitanteGrupoNombre: groupFile?.label || '',
            emisorSucursalCiudad: docOptions.documentoHijo.id,
            emisorSucursalPais: docOptions.documentoPadre.id,
            emisorContactoCargo: this.currentUser.cargo,
            transporteViaTransporteCodigoTransporte: 0,
            transporteNotas: '',
            solicitanteRut: this.currentUser.iut,
            solicitanteNombre: this.currentUser.nombre,
            solicitanteEmail: this.currentUser.correo,
            solicitanteDocumentoId: this.currentUser.id
          },
          observaciones: [
            {
              linea: '0',
              observacion: this.isGore
                ? (file.textPlainMatter ? file.textPlainMatter : file.matter) : file.matter.map((item) => item.text).join(',')
            }
          ],
          adjuntos: [
            {
              tipo: 'principal',
              adjuntoMime: this.activeElement.name,
              archivoId: fileInfo.data.archivo.archivoId,
              adjuntoNombre: this.activeElement.name,
              fecha: this.$moment(this.activeElement.creationDate).format('YYYY-MM-DD'),
              adjuntoUrl: fileInfo.data.archivo.adjuntoUrl
            },
            ...attachments
              .filter((fileFilter) => !fileFilter.codeType && !fileFilter.documentId)
              .map((attachment) => ({
                tipo: 'adjunto',
                adjuntoMime: attachment.mimeFile || attachment.mime || '',
                adjuntoNombre: attachment.name,
                fecha: this.$moment(attachment.creationDate).format('YYYY-MM-DD'),
                archivoId: attachment.id,
                adjuntoUrl: attachment.urlFile
              })),
            ...attachments
              .filter((fileFilter) => fileFilter.documentId)
              .map((attachment) => ({
                tipo: 'repositorio',
                adjuntoId: attachment.documentId,
                archivoId: attachment.id,
                adjuntoMime: attachment.mimeFile || attachment.mime || '',
                adjuntoNombre: attachment.name,
                fecha: this.$moment(attachment.creationDate).format('YYYY-MM-DD')
              }))
          ],
          referencias: [
            {
              linea: 1,
              tipoDocumento: docOptions.documentoHijo.valor,
              folio: this.activeElement.id
            }
          ],
          metadata: [
            { nombre: 'origin', tipo: 1, valor: 'repositorio' }
          ]
        };
        this.$refs.fillInfoFile.hide();
        try {
          const response = await createDnt(fileNumOf);
          if (response.data.codigo !== 10 || response.data.codigo !== '10') {
            this.loadingFile = false;
          }
          this.$bvToast.toast(
            `El expediente ${response.data.dnt.numero} ha sido creado`,
            {
              title: 'Expediente creado',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 15000
            }
          );
          this.loadingFile = false;
          await router.push({
            name: 'files-wizard-update',
            params: { wizard: 'flujo', id: response.data.dnt.febosId }
          });
        } catch (e) {
          console.log('e', e);
          this.loadingFile = false;
        }
      }
    },
    async sendToFlow() {
      if (this.activeElement.codeType) {
        this.$router.push({
          name: 'manage-doc-wizard-update',
          params: {
            wizard: 'fileFlow',
            id: this.activeElement.id,
            codeType: this.activeElement.codeType
          },
          query: {
            codeType: this.activeElement.codeType
          }
        });
        return;
      }
      this.$router.push({
        name: 'manage-doc-wizard-update',
        params: { wizard: 'fileFlow', id: this.activeElement.id }
      });
    },
    goToKanbanFolder() {
      this.$router.push({
        name: 'repository-folder-activities',
        params: { id: this.activeElement.id }
      });
    },
    goToKanban() {
      this.$router.push({
        name: 'repository-file-activities',
        params: { id: this.activeElement.id }
      });
    },
    openElement() {
      window.open(this.activeElement.downloadURL);
    },
    goToSearch() {
      this.$router.push({
        name: 'repository-search'
      });
    },
    toggleFilesSelection() {
      this.navigationElementsSelectionEnabled = !this.navigationElementsSelectionEnabled;

      if (!this.navigationElementsSelectionEnabled) {
        this.selectedNavigationElements = [];
        this.selectionType = null;
      }

      return this.navigationElementsSelectionEnabled;
    },
    toggleSendFilesToFlowSelection() {
      this.selectionType = this.selectionTypes.SEND_FILE_TO_FLOW;
      this.toggleFilesSelection();
    },
    sendSelectedNavigationElementsToFlow() {
      if (!this.selectedNavigationElements || this.selectedNavigationElements.length === 0) {
        return;
      }
      const fileName = `Masivo ${new Date().toLocaleDateString('es-CL')} ${new Date().toLocaleTimeString('en-GB')}`;
      this.$router.push({
        name: 'manage-doc-wizard-update',
        params: {
          wizard: 'massiveFlow',
          id: 'masivo',
          type: 'file',
          fileName,
          tipo: 'files',
          files: this.selectedNavigationElements.join(',')
        },
      });
    },
    sendFolderToFlow() {
      console.log('sendFolderToFlow', this.activeElement);
      this.$router.push({
        name: 'manage-doc-wizard-update',
        params: {
          wizard: 'massiveFlow',
          id: 'masivo',
          type: 'file',
          fileName: `Masivo ${new Date().toLocaleDateString('es-CL')} ${new Date().toLocaleTimeString('en-GB')}`,
          tipo: 'folder',
          repositoryId: this.activeElement.repositoryId,
          folderId: this.activeElement.id,
          ownerId: this.activeElement.ownerId
        }
      });
    },
    configureRules() {
      console.log('configureRules', this.activeElement);
      this.viewRules({ router: this.$router, folder: this.activeElement });
    },
    handleConfigureLockEditing() {
      if (!this.activeElement || this.activeElement.type !== 'folder') return;
      this.lockEditingSwitch = !!this.activeElement.blockEdit;
      this.lockEditingFeedback = '';
      this.showLockEditingModal = true;
    },
    async confirmLockEditing() {
      this.loadingLockEditing = true;
      try {
        await this.blockFolder({
          repositoryId: this.activeElement.repositoryId,
          folderId: this.activeElement.id,
          bloqueada: this.lockEditingSwitch
        });
        this.lockEditingFeedback = this.lockEditingSwitch
          ? 'La edición en línea ha sido bloqueada correctamente para la carpeta.'
          : 'La edición en línea ha sido desbloqueada correctamente para la carpeta.';
        this.showLockEditingModal = false;
        // Aquí podrías actualizar el estado local si es necesario
      } catch (e) {
        this.lockEditingFeedback = 'Ocurrió un error al actualizar el bloqueo de edición.';
      } finally {
        this.loadingLockEditing = false;
      }
    },
    handleConfigureTemplate() {
      if (!this.activeElement || this.activeElement.type !== 'folder') return;
      this.templateSwitch = !!this.activeElement.isTemplate;
      this.templateFeedback = '';
      this.showTemplateModal = true;
    },
    async confirmTemplate() {
      this.loadingTemplate = true;
      try {
        await this.templateFolder({
          repositoryId: this.activeElement.repositoryId,
          folderId: this.activeElement.id,
          template: this.templateSwitch
        });
        this.templateFeedback = this.templateSwitch
          ? 'La carpeta ha sido marcada como Template correctamente.'
          : 'La carpeta ha sido desmarcada como Template correctamente.';
        this.showTemplateModal = false;
        // Aquí podrías actualizar el estado local si es necesario
      } catch (e) {
        console.error(e);
        this.templateFeedback = 'Ocurrió un error al actualizar la carpeta.';
      } finally {
        this.loadingTemplate = false;
      }
    },
    isSelectableNavigationElement(element) {
      if (this.selectionType === this.selectionTypes.SEND_FILE_TO_FLOW) {
        return element.approvalState === ApprovalStateTypes.NOT_APPLY
          && (element.publicationState === PublicationStateTypes.PUBLISHED
            || element.publicationState === PublicationStateTypes.DRAFT);
      }

      return false;
    },
    handleAcceptSelection() {
      if (this.selectedNavigationElements.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: 'Ups!',
          text: 'Debes seleccionar archivos antes de continuar',
          acceptText: 'Ok'
        });
      }
      if (this.selectionType === this.selectionTypes.SEND_FILE_TO_FLOW) {
        this.sendSelectedNavigationElementsToFlow();
      }
    },
    handleCancelSelection() {
      this.toggleFilesSelection();
    },
    addFolder() {
      this.isEdit = false;
      this.showModals('folderFormED');
    },
    editFolder() {
      this.isEdit = true;
      this.showModals('folderFormED');
    },
    deleteFolder() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '¡Advertencia!',
        text: '¿Está seguro de eliminar la carpeta? Al eliminarla también lo harás con archivos y sub carpetas que esta contenga.',
        accept: () => {
          this.confirmDeleteFolder();
        },
        acceptText: 'Confirmar',
        cancelText: 'Cancelar'
      });
    },
    async confirmDeleteFolder() {
      const { name } = this.getSelectedElement;
      await this.removeFolder({
        folderId: this.getSelectedElement.id,
        repositoryId: this.getSelectedElement.repositoryId,
      });
      this.$bvToast.toast(
        `La carpeta ${name} ha sido eliminada`,
        {
          title: 'Eliminar carpeta',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 15000
        }
      );
    },
    addFile() {
      this.isEdit = false;
      this.showModals('fileFormED');
    },
    editDataFile() {
      this.isEdit = true;
      this.showModals('fileFormED');
    },
    deleteFile() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '¡Advertencia!',
        text: '¿Está seguro de eliminar el documento?',
        accept: () => {
          this.confirmDeleteFile();
        },
        acceptText: 'Confirmar',
        cancelText: 'Cancelar'
      });
    },
    editCpshInfo() {
      this.showEditCpshModal = true;
      this.loadingCpshData = true;
      this.cpshData = null;
      this.cpshEditForm = {};
      this.cpshFieldErrors = {};
      this.editableFields = [];

      const codeType = this.activeElement && this.activeElement.codeType;
      if (!codeType) {
        this.loadingCpshData = false;
        return;
      }

      // Cargar la opción del grupo "documents-editable-fields" filtrando por codeType
      const fieldsPromise = listOptions({
        grupoOpcion: 'documents-editable-fields',
        deshabilitado: 'no',
      })
        .then(({ data }) => {
          const opciones = data.opciones || [];
          const target = opciones.find((o) => o.valor === codeType);
          if (!target) {
            this.editableFields = [];
            return;
          }

          let extra = {};
          try { extra = JSON.parse(target.extra); } catch { /* */ }

          const configuracion = (extra && extra.configuracion) || {};
          this.editableFields = Object.entries(configuracion).map(([id, def]) => ({
            id,
            title: def.titulo || id,
            type: def.tipo,
            default: def.default,
            opciones: def.opciones || [],
            opcional: !!def.opcional,
          }));
        })
        .catch(() => {
          this.editableFields = [];
        });

      const documentPromise = ioGetCustomDocument(codeType, this.activeElement.id, {})
        .then(({ data: { document } }) => {
          this.cpshData = document;
          return document;
        })
        .catch(() => {
          this.cpshData = null;
          return null;
        });

      // Cuando ambas terminen, precargar el form y cargar grupos si hace falta
      Promise.all([fieldsPromise, documentPromise]).then(() => {
        const document = this.cpshData;
        if (!document) {
          this.loadingCpshData = false;
          return;
        }

        const form = {};
        this.editableFields.forEach((field) => {
          if (field.type === 'usuarios') {
            const completeKey = `${field.id}Complete`;
            const complete = document[completeKey];
            form[field.id] = complete ? complete.value : (document[field.id] || field.default || '');
            form[completeKey] = complete || {};
          } else {
            let value;
            if (document[field.id] != null) {
              value = document[field.id];
            } else if (field.default != null) {
              value = field.default;
            } else {
              value = '';
            }
            form[field.id] = value;
          }
        });
        this.cpshEditForm = form;

        // Cargar grupos solo si hay algún campo de tipo "grupos"
        const needsGroups = this.editableFields.some((f) => f.type === 'grupos');
        if (needsGroups) {
          this.loadingCpshGroups = true;
          ioCompanyGroups({ empresaId: this.currentUser.empresaId })
            .then(({ data: g }) => {
              const groups = g.grupos || g || [];
              this.cpshCompanyGroups = groups.sort((a, b) => (a.nombre || '').toLowerCase().localeCompare((b.nombre || '').toLowerCase()));
              this.editableFields
                .filter((f) => f.type === 'grupos')
                .forEach((f) => {
                  const current = this.cpshEditForm[f.id];
                  if (current && current.id) {
                    const found = this.cpshCompanyGroups.find((gr) => gr.id === current.id);
                    this.$set(this.cpshEditForm, f.id, found || null);
                  }
                });
            })
            .catch(() => { this.cpshCompanyGroups = []; })
            .finally(() => { this.loadingCpshGroups = false; });
        }

        this.loadingCpshData = false;
      });
    },
    saveCpshInfo() {
      const codeType = this.activeElement && this.activeElement.codeType;
      if (!codeType) return;

      // Validar campos obligatorios antes de guardar
      const errors = {};
      this.editableFields
        .filter((f) => !f.opcional && f.type !== 'info')
        .forEach((f) => {
          const val = this.cpshEditForm[f.id];
          let isEmpty = false;
          if (f.type === 'grupos') {
            isEmpty = !val || !val.id;
          } else if (f.type === 'usuarios') {
            const complete = this.cpshEditForm[`${f.id}Complete`];
            isEmpty = !complete || !complete.value;
          } else {
            isEmpty = !val || (typeof val === 'string' && !val.trim());
          }
          if (isEmpty) errors[f.id] = true;
        });

      this.cpshFieldErrors = errors;

      if (Object.keys(errors).length) return;

      this.savingCpsh = true;

      // Armar el body con solo los campos editables (mismo formato que tiene el doc original)
      const body = {};
      const fieldLabels = {};
      this.editableFields.forEach((field) => {
        const value = this.cpshEditForm[field.id];
        fieldLabels[field.id] = field.title;
        if (field.type === 'usuarios') {
          // Guardar tanto el value (string) como el Complete (objeto), igual que SCH/CPSH
          const completeKey = `${field.id}Complete`;
          body[field.id] = value || '';
          body[completeKey] = this.cpshEditForm[completeKey] || {};
        } else if (field.type === 'grupos') {
          // v-select almacena el objeto completo {id, nombre}
          body[field.id] = value || null;
        } else {
          body[field.id] = value != null ? value : '';
        }
      });

      // Enviar labels para bitácora legible (el backend lo usa y no lo guarda)
      body._fieldLabels = fieldLabels;

      ioPatchCustomDocument(codeType, this.activeElement.id, body)
        .then(() => {
          this.$bvToast.toast(
            'Información del convenio actualizada correctamente',
            {
              title: 'Editar CPSH',
              variant: 'success',
              solid: true,
              autoHideDelay: 3000
            }
          );
          this.showEditCpshModal = false;
        })
        .catch((err) => {
          this.$bvToast.toast(
            (err && err.message) || 'No se pudo guardar la información del convenio',
            {
              title: 'Error al guardar',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000
            }
          );
        })
        .finally(() => {
          this.savingCpsh = false;
        });
    },
    async confirmDeleteFile() {
      const { name } = this.getSelectedElement;
      await this.removeFile({
        fileId: this.activeElement.id,
        repositoryId: this.activeElement.repositoryId,
      });
      this.$bvToast.toast(
        `El documento ${name} ha sido eliminado`,
        {
          title: 'Eliminar documento',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 15000
        }
      );
    },
    onChange() {
      this.filesToUpload = [...this.$refs.file.files];
    },
    dragover(event) {
      this.dragging = true;
      event.preventDefault();
    },
    dragleave(event) {
      this.dragging = false;
      event.preventDefault();
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();
      const that = this;
      this.filesToUpload.forEach((file) => {
        const unique = file.name + file.lastModified;
        that.individualProgress[unique] = 0;
      });
      this.filesToUpload.forEach((file) => {
        const urlTransito = `${baseUrl}${uuid.v1()}`;
        this.uploadFileToS3(file, urlTransito);
      });
    },
    async uploadFileToS3(file, url) {
      try {
        const response = await ioGetPrivateUploadUrl(url, file.type);
        const that = this;
        await ioUploadFileToPrivateUrl(
          response.data?.url,
          file,
          (percent) => {
            const unique = file.name + file.lastModified;
            that.individualProgress[unique] = percent;
            that.updateProgress();
          }
        );
        this.uploadFile({
          repositoryId: this.repositoryId,
          folderId: this.getSelectedFolderId,
          file: {
            carpetaId: this.getSelectedFolderId,
            nombre: file.name,
            urlTransito: url,
            esPublico: 'N',
            idioma: 'es',
            versionExterna: '',
            estadoVigencia: this.validityStateTypes.NOT_APPLY,
            estadoAprobacion: this.approvalStateTypes.NOT_APPLY,
            estadoPublicacion: this.publicationStateTypes.DRAFT
          }
        });
      } catch (e) {
        console.error(e);
      }
      return url;
    },
    updateProgress() {
      const sumProgress = Object.values(this.individualProgress).reduce((t, n) => t + n);
      if (sumProgress === 0) this.progress = 0;
      const current = sumProgress * 100;
      const max = this.filesToUpload.length * 100;
      this.progress = Math.round(current / max);
    },
    newDocument() {
      this.showModals('newCustomDocument');
    },
    openEdictDocument() {
      const { token } = this.currentUser;
      const filePath = `${currentStage}/f3-${token}/escritorio-digital/chile/${currentStage}/repositorios/${this.activeElement.repositoryId}/${this.activeElement.id}/:::/${this.activeElement.name}`;
      const url = getUrlEditDocument(filePath, this.activeElement.name);
      window.location = url;
    },
    downloadFolder() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '¡Advertencia!',
        text: '¿Está seguro de descargar toda la carpeta?',
        accept: () => {
          this.downloadFolderConfirm();
        },
        acceptText: 'Confirmar',
        cancelText: 'Cancelar'
      });
    },
    async downloadFolderConfirm() {
      await initProcessFromId(
        {
          id: 'Descarga_Repo',
          payload: {
            repositorioId: this.activeElement.repositoryId,
            documentos: [this.activeElement.id]
          }
        }
      );
      this.$bvToast.toast(
        'Se ha iniciado el proceso, se te informará por correo el estado de este',
        {
          title: 'Comprimiendo la carpeta',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 15000
        }
      );
    },
    async handleNewTemplateDocument() {
      this.showNewTemplateDocumentModal = true;
      this.wizardStep = 1;
      this.selectedTemplateFile = null;
      this.editableTemplateName = '';
      this.fetchTemplatesFiles(1);
    },
    fetchTemplatesFiles(page = 1) {
      this.loadingTemplates = true;
      // Reemplaza esto por tu llamada real a findTemplatesFiles
      this.findTemplatesFiles({
        pagina: page,
        elementosPorPagina: this.templatesPagination.elementosPorPagina
      })
        .then((resp) => {
          this.templatesFiles = resp.documentos;
          this.templatesPagination.paginaActual = resp.paginaActual;
          this.templatesPagination.totalPaginas = resp.totalPaginas;
          this.templatesPagination.totalElementos = resp.totalElementos;
        })
        .finally(() => {
          this.loadingTemplates = false;
        });
    },
    selectTemplateFile(file) {
      this.selectedTemplateFile = file;
      this.editableTemplateName = file.nombre;
      this.wizardStep = 2;
    },
    backToTemplateList() {
      this.wizardStep = 1;
      this.selectedTemplateFile = null;
      this.editableTemplateName = '';
    },
    async confirmTemplateSelection() {
      if (this.selectedTemplateFile) {
        this.loadingCopyTemplateDocument = true;
        let createdDocId = null;
        try {
          // Detectar y restaurar extensión si fue eliminada
          const originalName = this.selectedTemplateFile.nombre;
          const originalExt = originalName.includes('.') ? originalName.substring(originalName.lastIndexOf('.')) : '';
          let finalName = this.editableTemplateName;
          if (originalExt && !finalName.toLowerCase().endsWith(originalExt.toLowerCase())) {
            finalName += originalExt;
          }
          this.editableTemplateName = finalName;
          const response = await this.uploadFile({
            repositoryId: this.repositoryId,
            folderId: this.getSelectedFolderId,
            file: {
              source: 'template',
              carpetaId: this.getSelectedFolderId,
              nombre: this.editableTemplateName,
              archivoId: this.selectedTemplateFile.id
            }
          });
          const resp = response.data.archivo;
          // Intentar obtener el id del documento creado
          createdDocId = resp.archivoId;
          this.lastCreatedTemplateDocument = {
            id: createdDocId,
            nombre: this.editableTemplateName,
            ...resp
          };
          this.resetNewTemplateDocumentModal();
          this.showNewTemplateDocumentModal = false;
          // Mostrar toast de éxito
          app.$bvToast.toast(
            'El documento fue creado desde el template.',
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 8000
            }
          );

          // Si tiene permiso ED241, preguntar si quiere abrir el documento
          if (this.hasPermission && this.hasPermission('ED241') && createdDocId) {
            if (isMicrosoftOfficeDocument(this.editableTemplateName)) {
              this.showOpenAfterCopyModal = true;
            }
          }
        } catch (e) {
          app.$bvToast.toast(
            'Ocurrió un error al crear el documento desde el template.',
            {
              title: 'Error',
              variant: 'danger',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 8000
            }
          );
        } finally {
          // Solo cerrar el loading si NO hay que mostrar el modal de abrir documento
          if (!this.showOpenAfterCopyModal) {
            this.loadingCopyTemplateDocument = false;
          }
        }
      }
    },
    resetNewTemplateDocumentModal() {
      this.showNewTemplateDocumentModal = false;
      this.selectedTemplateDocument = null;
      this.newTemplateDocumentName = '';
      this.loadingTemplates = false;
      this.templatesFiles = [];
      this.templatesPagination = { paginaActual: 1, totalPaginas: 1 };
    },
    // Nuevo método para manejar la decisión del usuario
    handleOpenAfterCopy(decision) {
      this.showOpenAfterCopyModal = false;
      this.loadingCopyTemplateDocument = false;
      if (decision && this.lastCreatedTemplateDocument && this.lastCreatedTemplateDocument.id) {
        // Llama a openEdictDocument con el id del nuevo documento
        this.openEdictDocumentById(this.lastCreatedTemplateDocument.id);
      }
      this.lastCreatedTemplateDocument = null;
    },
    // Nuevo método para abrir documento por id
    openEdictDocumentById(id) {
      // Busca el documento en la lista de archivos o crea un objeto temporal
      const doc = this.templatesFiles.find((f) => f.id === id)
        || {
          id,
          name: this.editableTemplateName,
          repositoryId: this.repositoryId
        };
      // Simula el contexto necesario para openEdictDocument
      this.activeElement = {
        ...doc,
        repositoryId: this.repositoryId
      };
      if (isMicrosoftOfficeDocument(this.activeElement.name)) {
        this.openEdictDocument();
      } else {
        // Si no es un documento de Office, simplemente abrirlo en una nueva pestaña
        const url = this.activeElement.downloadURL || getUrlEditDocument(
          `${currentStage}/f3-${this.currentUser.token}/escritorio-digital/chile/${currentStage}/repositorios/${this.activeElement.repositoryId}/${this.activeElement.id}/:::/${this.activeElement.name}`,
          this.activeElement.name
        );
        window.open(url, '_blank');
      }
    },
  },
  computed: {
    ...mapGetters('Empresas', [
      'companyId', 'iut', 'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser',
      'hasPermission'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('List', [
      'userGroupsState'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getSelectedFolderId',
      'getSelectedElement',
      'getTreeElements',
      'getFilesStack',
      'getRepositories',
      'loadingLoadingTemplates',
      'loadingElements',
      'loading',
      'getPermissionsStack'
    ]),
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    },
    cpshModalTitle() {
      const name = this.activeElement && this.activeElement.name;
      return name
        ? `Editar información del convenio ${name}`
        : 'Editar información del convenio';
    },
    noHavPermissions() {
      return this.userPermissions.read === 0
        && this.userPermissions.write === 0
        && this.userPermissions.totalControl === 0;
    },
    isReadOnly() {
      return this.userPermissions.write === 0 && this.userPermissions.totalControl === 0;
    },
    canWrite() {
      return this.userPermissions.write === 1 || this.userPermissions.totalControl === 1;
    },
    isDocx() {
      return isMicrosoftOfficeDocument(this.activeElement.name);
    },
    isInh() {
      return this.company.iut === INH.iut;
    },
    isGore() {
      return this.company.iut === '72235100-2';
    },
    groupsUser() {
      return this.userGroupsState.list
        .filter((group) => group.isOffice === 'N')
        .filter((groupFilter) => !groupFilter.parentId || groupFilter.parentId === '');
    },
    showDrangAndDropUploader() {
      return this.dragging || this.filesToUpload.size > 0;
    },
    repositoryId() {
      let response = '';
      if (this.getSelectedFolderId) {
        response = this.getTreeElements[this.getSelectedFolderId].repositoryId;
      }
      if (this.getSelectedRepositoryId) {
        response = this.getSelectedRepositoryId;
      }
      return response;
    },
    elementName() {
      let response = '';
      if (this.getSelectedRepositoryId) {
        response = this.getRepositories[this.getSelectedRepositoryId].nombreRepositorio;
      }
      if (this.getSelectedFolderId) {
        response = this.getTreeElements[this.getSelectedFolderId].nombre;
      }
      return response;
    },
    canEdit() {
      console.group('canEdit');
      try {
        console.debug('this.getSelectedRepositoryId', this.getSelectedRepositoryId);
        console.debug('this.getRepositories[this.getSelectedRepositoryId]', this.getRepositories[this.getSelectedRepositoryId]);
        if (
          this.getSelectedRepositoryId
          && this.getRepositories[this.getSelectedRepositoryId].blockEdit
        ) {
          return false;
        }
        console.debug('&& this.getTreeElements[this.getSelectedFolderId]', this.getTreeElements[this.getSelectedFolderId]);
        if (
          this.getSelectedFolderId
          && this.getTreeElements[this.getSelectedFolderId].blockEdit
        ) {
          return false;
        }
        return true;
      } finally {
        console.groupEnd('canEdit');
      }
    },
    isEmptyFolder() {
      if (!this.loading && !this.folderElements.length && !this.fileElements.length) {
        return true;
      }
      return false;
    },
    actualFolder() {
      if (this.getSelectedRepositoryId) {
        return this.getRepositories[this.getSelectedRepositoryId];
      }
      if (this.getSelectedFolderId) {
        return this.getTreeElements[this.getSelectedFolderId];
      }
      return null;
    },
    filteredTemplatesFiles() {
      if (!this.templateSearch) {
        return this.templatesFiles;
      }
      const searchTerm = this.templateSearch.toLowerCase();
      return this.templatesFiles.filter((file) => file.nombre.toLowerCase().includes(searchTerm));
    }
  },
  watch: {
    getSelectedElement() {
      const selectedElement = this.getSelectedElement || {};
      this.activeElement = this.getSelectedElement || {};
      this.userPermissions.read = selectedElement.loggedUserPermissions?.lectura;
      this.userPermissions.write = selectedElement.loggedUserPermissions?.escritura;
      this.userPermissions.totalControl = selectedElement.loggedUserPermissions?.controlTotal;
    },
    getTreeElements() {
      this.folderElements = [];
      let folders = {};
      if (this.getSelectedRepositoryId) {
        folders = Object.values(this.getTreeElements)
          .filter((element) => (
            element.parentFolder === null && element.repositoryId === this.getSelectedRepositoryId
          ));
      }
      if (this.getSelectedFolderId) {
        folders = Object.values(this.getTreeElements)
          .filter((element) => (
            element.parentFolder === this.getSelectedFolderId
          ));
      }
      this.folderElements = folders.map((folder) => ({
        id: folder.carpetaId,
        name: folder.nombre,
        fullpathId: folder.fullpathId,
        parentFolder: folder.parentFolder,
        repositoryId: folder.repositoryId,
        creationDate: folder.fechaCreacion,
        ownerId: folder.propietario.id,
        owner: folder.propietario.alias,
        numberOfFiles: folder.cantidadArchivos,
        numberOfFolders: folder.cantidadCarpetas,
        blockEdit: folder.blockEdit || 0,
        template: folder.template || 0,
        tags: [],
        keywords: [],
        type: 'folder'
      }));
    },
    getFilesStack() {
      this.fileElements = [];
      let files = [];
      if (this.getSelectedRepositoryId) {
        files = Object.values(this.getFilesStack)
          .filter((element) => (
            element.parentFolder === null && element.repositoryId === this.getSelectedRepositoryId
          ));
      }
      if (this.getSelectedFolderId) {
        files = Object.values(this.getFilesStack)
          .filter((element) => (
            element.parentFolder === this.getSelectedFolderId
          ));
      }
      this.fileElements = files.map((file) => ({
        id: file.archivoId,
        name: file.nombre,
        codeType: file.codType,
        creationDate: file.fechaCreacion,
        publicationDate: file.fechaPublicacion,
        parentFolder: file.parentFolder,
        ownerId: file.propietario.id,
        owner: file.propietario.alias,
        size: file.pesoArchivo,
        mimeFile: file.mime,
        documentId: file.documentoId,
        type: 'file',
        repositoryId: file.repositoryId,
        urlFile: file.urlAdjunto,
        downloadURL: `${file.urlDescarga}?t=${this.currentUser.token}&e=${this.companyId}`,
        publicLink: file.esPublico === 'S' ? file.urlDescarga : undefined,
        isPublic: file.esPublico === 'S',
        externalVersion: file.versionExterna,
        publicationState: file.estadoPublicacion,
        validityState: file.estadoVigencia,
        approvalState: file.estadoAprobacion,
        expirationDate: file.fechaVencimiento,
        expirationType: file.tipoExpiracion
      }));
    },
    getSelectedFolderId() {
      this.folderElements = [];
      this.fileElements = [];
      if (this.getSelectedFolderId) {
        this.selectedElement = this.getTreeElements[this.getSelectedFolderId];
      }
    },
    getSelectedRepositoryId() {
      this.folderElements = [];
      this.fileElements = [];
      if (this.getSelectedRepositoryId) {
        this.selectedElement = this.getRepositories[this.getSelectedRepositoryId];
      }
    },
    progress(value) {
      if (value === 100) {
        this.filesToUpload = [];
        this.dragging = false;
        this.individualProgress = {};
        this.progress = 0;
      }
    },
    selectedElement() {
      if (this.selectedElement.propietarioId === this.companyId) {
        const activo = 1;
        this.userPermissions.read = activo;
        this.userPermissions.write = activo;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.view-panel {
  height: 33vh;
}

.view-panel-full {
  height: 70vh;
}

.view-table {
  height: 28vh;
  margin-top: 0.5rem !important;
}

.drop-icon-holder {
  margin-top: 50px;
  margin-left: 50%;
  width: 50px;
  left: -25px;
  position: relative;
}

.drop-icon {
  font-size: 50px;
  color: #ccc;
}

.drag {
  border: dashed 2px #ddd;
  background-color: #eee !important;
}

.drag .help {
  text-align: center;
  margin-top: 30px;
  color: #1e1e1e;
}

.progress-content {
  display: inline-block;
}

.progress-content:first-child {
  vertical-align: sub;
}

.progress-wrapper {
  margin-top: 50px;
  text-align: center;
}

.fb-bg-primary {
  background-color: rgb(var(--vs-primary));
}

.toggle {
  height: 20vh !important;
  overflow: hidden;
}

.separator {
  display: inline-block;
  width: 20px;
}

#folder-elements {
  /* no eliminar! es por propositos de manejo de UI */
}

.template-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 6px;
  overflow: hidden;
}

.template-table th {
  background: #f5f6fa;
  color: #333;
  font-weight: 600;
  padding: 10px 8px;
  border-bottom: 1px solid #eaeaea;
}

.template-table td {
  padding: 8px 8px;
  border-bottom: 1px solid #f0f0f0;
  color: #444;
}

.template-table tr.selected-row {
  background: #e3f2fd;
  font-weight: bold;
}

.template-table tr:hover {
  background: #f0f7fa;
}

.wizard-step-2 {
  padding: 20px 0 0 0;
}

#templateNameInput {
  font-size: 1.1em;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  margin-top: 8px;
}
</style>
